import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Form, Formik, FormikProps } from 'formik';
import * as Yup from 'yup';

import BounceLoader from '@common/react/components/UI/Loaders/BounceLoader';

import CustomCheckbox from '@app/components/Forms/CustomCheckbox/CustomCheckbox';
import PasswordShowHide from '@app/components/LocalCommon/PasswordShowHide/PasswordShowHide';
import CustomInput from '@app/components/UI/CustomInput/CustomInput';
import RecoverForm from '@app/components/UI/Login/RecoverForm';
import CloseSVG from '@app/images/icons/CloseSVG';
import { ApplicationState } from '@app/store';
import * as LoginState from '@app/store/Login';

const mailIcon = require('@app/images/icons/mail.svg');
const lockIcon = require('@app/images/icons/lock.svg');

interface LoginFormProps {
	setModalVisible: (e: boolean) => void;
}

const validationSchema = Yup.object({
	email: Yup.string().email('Value must be a valid Email address').required('Email is a required field'),
	password: Yup.string().required('Password is a required field'),
});

const LoginForm: React.FC<LoginFormProps> = ({ setModalVisible }) => {
	const dispatch = useDispatch();
	const actions = bindActionCreators(LoginState.getActionCreators(), dispatch);
	const login = useSelector((state: ApplicationState) => state.login, shallowEqual);
	const isLoadingLogin = useSelector((state: ApplicationState) => state.login.isLoading, shallowEqual);

	const [checked, setChecked] = React.useState(false);
	const [showRecover, setShowRecover] = React.useState<boolean>(false);

	const closeModal = () => {
		setModalVisible(false);
	};

	return (
		<div className="login">
			<div className="login__body">
				<CloseSVG className="close" onClick={closeModal} />

				{!showRecover ? (
					!isLoadingLogin ? (
						<>
							<h1 className="head__title h2 text-center">Sign in</h1>
							<p className="h4 text-center">Sign in to track your pet’s quality of life.</p>

							<Formik
								onSubmit={(values) => {
									actions.login(values.email, values.password, 'auth', checked ?? false);
								}}
								initialValues={{
									email: '',
									password: '',
								}}
								validationSchema={validationSchema}
							>
								{(formikBag: FormikProps<any>) => {
									return (
										<Form className="login-form h4">
											<div className="login-form__fields">
												<CustomInput name="email" type="email" placeholder="Email Address" formikBag={formikBag} prefixIcon={mailIcon} />
												<CustomInput
													name="password"
													placeholder="Password"
													type="password"
													formikBag={formikBag}
													prefixIcon={lockIcon}
													component={PasswordShowHide}
												/>
											</div>

											<div className="login-form__row">
												<div className="login-form__row__keep">
													<CustomCheckbox onChangeChecked={setChecked} formikBag={formikBag} capture="Keep me signed in" />
												</div>
												<div className="login-form__row__forgot">
													<a
														href="#"
														onClick={(e) => {
															e.preventDefault();
															setShowRecover(true);
														}}
													>
														Forgot your password?
													</a>
												</div>
											</div>

											<div className="login__btns">
												<button type="submit" className="btn btn-primary btn-md">
													Sign in
												</button>
											</div>

											{login.message && (
												<p className="login-form__fields-error">{login.message}</p>
											)}

											<div className="register-account text-center">
												Don’t have an account?
												{' '}
												<NavLink to="/create-profile" onClick={closeModal}>
													Register now
												</NavLink>
											</div>
										</Form>
									);
								}}
							</Formik>
						</>
					) : <BounceLoader />
				) : (
					<RecoverForm />
				)}
			</div>
		</div>
	);
};

export default LoginForm;
